module.exports = __webpack_public_path__ + "img/5_f41430c0f.png";